import { render, staticRenderFns } from "./ShoesHero.vue?vue&type=template&id=2953c448&scoped=true"
var script = {}
import style0 from "./ShoesHero.vue?vue&type=style&index=0&id=2953c448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953c448",
  null
  
)

export default component.exports